export default __webpack_public_path__ + "static/media/settle-1.023c3a13.png";